import { useEffect, useState } from "react";

import { type KeystoneDocusignStatus } from "data/keystone-api-mapping";
import { useDocumentsToSign } from "data/ss-data-hooks";
import { getCookie } from "utils";

const RECIPIENT_STATUSES_TO_SHOW = ["sent", "declined", "delivered"];
const DOCUMENT_STATUSES_TO_SHOW = [
  "SENT",
  "DECLINED",
  "EXPIRED",
  "DELIVERY_FAILURE",
  "DELIVERED",
];

export const useEnvelopeToSign = () => {
  const hideDocumentsToSign = getCookie("hide-documents-to-sign");
  // We're ignoring errors and just not rendering in that case
  const { data, isLoading } = useDocumentsToSign();

  const [envelopeToSign, setEnvelopeToSign] =
    useState<KeystoneDocusignStatus | null>(null);
  useEffect(() => {
    const applicableDocuments = hideDocumentsToSign
      ? []
      : (data?.filter(
          (status) =>
            // EasyPay documents are a kinda weird side effect of the way we sign up for easy pay
            // They don't actually need to be signed
            status?.documentType !== "EasyPay" &&
            status?.documentType !== "" &&
            DOCUMENT_STATUSES_TO_SHOW.includes(status?.documentStatus ?? ""),
        ) ?? []);

    applicableDocuments.sort((a, b) =>
      a?.createdDateTime > b?.createdDateTime ? -1 : 1,
    );

    const signers = applicableDocuments[0]?.signers ?? [];
    const recipientStatus = signers[0]?.status ?? "";

    setEnvelopeToSign(
      RECIPIENT_STATUSES_TO_SHOW.includes(recipientStatus)
        ? applicableDocuments[0]
        : null,
    );
  }, [data, hideDocumentsToSign]);

  return { envelopeToSign, loading: isLoading };
};
